interface ServiceErrorLike {
  code?: string;
  message?: string;
}

function asServiceError(error: unknown): ServiceErrorLike {
  if (error && typeof error === 'object') {
    return error as ServiceErrorLike;
  }

  return {};
}

export function getDataServiceErrorMessage(error: unknown): string {
  const serviceError = asServiceError(error);
  const message = serviceError.message ?? '';

  if (
    serviceError.code === 'PGRST202' ||
    serviceError.code === 'PGRST205' ||
    message.includes('schema cache') ||
    message.includes('Could not find the function') ||
    message.includes('Could not find the table')
  ) {
    return 'Radyo veritabanı henüz kurulmamış. Supabase migration dosyalarını uygulayın.';
  }

  return 'Radyo listesine şu anda ulaşılamıyor. Lütfen biraz sonra tekrar deneyin.';
}

export function getEdgeFunctionErrorMessage(
  functionName: string,
  status: number,
  detail: string,
): string {
  if (status === 404) {
    return `Supabase Edge Function “${functionName}” bulunamadı. Fonksiyonu Supabase projesine deploy edin.`;
  }

  if (status === 401 || status === 403) {
    return `Supabase Edge Function “${functionName}” için erişim reddedildi. Anon key ve JWT ayarlarını kontrol edin.`;
  }

  return detail
    ? `Supabase işlemi başarısız oldu (${status}): ${detail}`
    : `Supabase işlemi başarısız oldu (${status}).`;
}
